import type { RouteLocationRaw } from "#vue-router";

export function handleLinkClick(event: MouseEvent, to: RouteLocationRaw) {
  event.preventDefault();
  event.stopPropagation();

  const router = useRouter();

  if (event.metaKey || event.ctrlKey) {
    return window.open(router.resolve(to).href);
  }

  return navigateTo(to);
}

/**
 * A `?redirect=` value, only if it is somewhere in this app.
 *
 * The value comes off the URL, so it is whatever the person following the link
 * was handed: a bare `//evil.example` is a protocol-relative URL, and `https://…`
 * an absolute one — both would send someone off the app on a *successful* sign-in,
 * which is the one moment they are least likely to look at the address bar.
 *
 * Anything that is not a single-slash path falls back to the root.
 */
export function toSafeRedirect(value: unknown, fallback = "/"): string {
  return typeof value === "string" &&
    value.startsWith("/") &&
    !value.startsWith("//")
    ? value
    : fallback;
}
